"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicHTMLModal = exports.ReactModal = exports.default = void 0;

var _decorators = require("decorators");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _react = babelHelpers.interopRequireDefault(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _class, _descriptor, _temp, _class3, _descriptor2, _temp2;

var Modal = (_class3 = (_temp2 =
/*#__PURE__*/
function () {
  babelHelpers.createClass(Modal, [{
    key: "getModalContent",
    value: function getModalContent() {
      var _this5 = this;

      return new _promisePolyfill.default(function (resolve) {
        return resolve(_this5.modalContent);
      });
    }
  }, {
    key: "icon",
    get: function get() {
      return "";
    }
  }, {
    key: "title",
    get: function get() {
      return "Modal";
    }
  }, {
    key: "subTitle",
    get: function get() {
      return "";
    }
  }, {
    key: "modalContent",
    get: function get() {
      return "";
    }
  }]);

  function Modal(id) {
    babelHelpers.classCallCheck(this, Modal);
    this.element = null;
    babelHelpers.initializerDefineProperty(this, "modalCloseButton", _descriptor2, this);
    this.classList = ['modal', 'modal-full', 'fade'];
    this.modalTitleElement = 'h4';
    this.innerWrapper = true;
    this.hasModalTitleElement = true;
    this.removeOnHide = false;
    this.isShowing = false;
    this.modalBodyInnerClasses = [];
    this.id = id;
  }

  babelHelpers.createClass(Modal, [{
    key: "updateTitle",
    value: function updateTitle() {
      if (this.element) {
        var H = this.element.querySelector('.modal-header');
        if (H) H.innerHTML = "\n\t\t\t\t".concat(this.modalCloseButton, "\n\t\t\t\t").concat(this.hasModalTitleElement ? "\n\t\t\t\t\t\t<".concat(this.modalTitleElement, " class='modal-title'>\n\t\t\t\t\t\t\t").concat(this.icon, "\n\t\t\t\t\t\t\t").concat(this.title, " ").concat(this.subTitle ? "<strong>".concat(this.subTitle, "</strong>") : '', "\n\t\t\t\t\t\t</").concat(this.modalTitleElement, ">\n\t\t\t\t\t") : '', "\n\t\t\t");
      }
    }
  }, {
    key: "append",
    value: function append() {
      var _this6 = this;

      return this.getModalContent().then(function (content) {
        if (_this6.element && _this6.element.parentNode) _this6.element.parentNode.removeChild(_this6.element);
        var E = document.createElement('div');
        E.id = "".concat(_this6.id, "-wrap");
        E.className = 'modal-wrapper fade';
        E.innerHTML = "\n\t\t\t\t<div id='".concat(_this6.id, "' class='").concat(_this6.classList.join(' '), "' data-backdrop-parent='#").concat(_this6.id, "-wrap'>\n\t\t\t\t\t<div class='modal-dialog'>\n\t\t\t\t\t\t<div class='modal-content'>\n\t\t\t\t\t\t\t<div class='modal-header'>\n\t\t\t\t\t\t\t\t").concat(_this6.modalCloseButton, "\n\t\t\t\t\t\t\t\t").concat(_this6.hasModalTitleElement ? "\n\t\t\t\t\t\t\t\t\t\t<".concat(_this6.modalTitleElement, " class='modal-title'>\n\t\t\t\t\t\t\t\t\t\t\t").concat(_this6.icon, "\n\t\t\t\t\t\t\t\t\t\t\t").concat(_this6.title, " ").concat(_this6.subTitle ? "<strong>".concat(_this6.subTitle, "</strong>") : '', "\n\t\t\t\t\t\t\t\t\t\t</").concat(_this6.modalTitleElement, ">\n\t\t\t\t\t\t\t\t\t") : '', "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class='modal-body'>\n\t\t\t\t\t\t\t\t").concat(_this6.innerWrapper ? "\n\t\t\t\t\t\t\t\t\t<div class='container'>\n\t\t\t\t\t\t\t\t\t\t<div class='modal-body-inner ".concat(_this6.modalBodyInnerClasses.join(' '), "'>\n\t\t\t\t\t\t\t\t\t\t\t").concat(content, "\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t") : content, "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t");
        document.body.appendChild(E);
        _this6.element = E;
        return E;
      });
    }
  }, {
    key: "show",
    value: function show(promise) {
      var _this7 = this;

      return (promise || this.append()).then(function (element) {
        return new _promisePolyfill.default(function (resolve) {
          $(element).one('showing.bs.modal', function () {
            _this7.isShowing = true;
            resolve(element);
          });
          var top = document.body.scrollTop || document.documentElement.scrollTop;
          _this7._oldScrollTop = top;
          $(_this7.element).one('hidden.bs.modal', function () {
            _this7.isShowing = false;
            if (_this7.removeOnHide) $(_this7.element).remove();
            document.body.scrollTop = document.documentElement.scrollTop = top;
          });
          $(element).children('.modal').modal('show');
        });
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.element && this.element.parentNode) {
        $(this.element).children('.modal').modal('hide');
      }
    }
  }]);
  return Modal;
}(), _temp2), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "modalCloseButton", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return BLX.modalCloseButton();
  }
})), _class3);
exports.default = Modal;
var reactID = 1;
var ReactModal = (_class = (_temp =
/*#__PURE__*/
function (_Modal) {
  babelHelpers.inherits(ReactModal, _Modal);

  function ReactModal() {
    var _this;

    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    babelHelpers.classCallCheck(this, ReactModal);
    var x = "react-".concat(++reactID);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(ReactModal).call(this, id || x));
    _this.useReactContainer = true;
    babelHelpers.initializerDefineProperty(_this, "reactSelector", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.reactId = x + '-container';
    return _this;
  }

  babelHelpers.createClass(ReactModal, [{
    key: "setComponent",
    value: function setComponent(node) {
      this.component = node;

      if (this.isShowing) {
        if (this.component) {
          _reactDom.default.render(this.component, this.element.querySelector(this.reactSelector));
        } else {
          _reactDom.default.unmountComponentAtNode(this.element.querySelector(this.reactSelector));
        }
      }
    }
  }, {
    key: "show",
    value: function show() {
      var _babelHelpers$get,
          _this2 = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(ReactModal.prototype), "show", this)).call.apply(_babelHelpers$get, [this].concat(args)).then(function (element) {
        if (_this2.component) _reactDom.default.render(_this2.component, _this2.element.querySelector(_this2.reactSelector));
        $(_this2.element).one('hidden.bs.modal', function () {
          if (_this2.component) {
            _reactDom.default.unmountComponentAtNode(_this2.element.querySelector(_this2.reactSelector));
          }
        });
        return element;
      });
    }
  }, {
    key: "modalContent",
    get: function get() {
      if (this.useReactContainer) return "<div id='".concat(this.reactId, "'></div>");
      return '';
    }
  }]);
  return ReactModal;
}(Modal), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "reactSelector", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.useReactContainer ? "#".concat(this.reactId) : '.modal-body';
  }
})), _class);
exports.ReactModal = ReactModal;
var htmlID = 1;

var BasicHTMLModal =
/*#__PURE__*/
function (_Modal2) {
  babelHelpers.inherits(BasicHTMLModal, _Modal2);

  function BasicHTMLModal(content) {
    var _this3;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    babelHelpers.classCallCheck(this, BasicHTMLModal);
    var x = "html-".concat(++htmlID);
    _this3 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(BasicHTMLModal).call(this, options.id || x));
    _this3.removeOnHide = true;
    _this3.options = options;
    _this3.content = content;
    _this3.containerID = x;
    return _this3;
  }

  babelHelpers.createClass(BasicHTMLModal, [{
    key: "show",
    value: function show() {
      var _babelHelpers$get2,
          _this4 = this;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return (_babelHelpers$get2 = babelHelpers.get(babelHelpers.getPrototypeOf(BasicHTMLModal.prototype), "show", this)).call.apply(_babelHelpers$get2, [this].concat(args)).then(function (element) {
        if (babelHelpers.instanceof(_this4.content, HTMLElement)) {
          _this4._oldParent = _this4.content.parentNode;
          _this4._oldNextSibling = _this4.content.nextSibling;
          element.querySelector('#' + _this4.containerID + '-container').appendChild(_this4.content);
          $(_this4.element).one('hidden.bs.modal', function () {
            if (babelHelpers.instanceof(_this4.content, HTMLElement)) {
              if (_this4._oldParent) {
                _this4._oldParent.insertBefore(_this4.content, _this4._oldNextSibling);
              }
            }
          });
        }

        return element;
      });
    }
  }, {
    key: "icon",
    get: function get() {
      return this.options.icon || "";
    }
  }, {
    key: "title",
    get: function get() {
      return this.options.title || "";
    }
  }, {
    key: "subTitle",
    get: function get() {
      return this.options.subTitle || "";
    }
  }, {
    key: "modalContent",
    get: function get() {
      if (babelHelpers.instanceof(this.content, HTMLElement)) {
        return "<div id='".concat(this.containerID, "-container'></div>");
      }

      return this.content || "";
    }
  }]);
  return BasicHTMLModal;
}(Modal);

exports.BasicHTMLModal = BasicHTMLModal;